import React, { useState, useEffect } from 'react';
import { FaStar } from 'react-icons/fa';

const GitHubStars = ({ repoUrl, className = "" }) => {
  const [stars, setStars] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchStars = async () => {
      try {
        // Extract owner and repo from GitHub URL
        const urlParts = repoUrl.replace('https://github.com/', '').split('/');
        const owner = urlParts[0];
        const repo = urlParts[1];
        
        if (!owner || !repo) {
          setError(true);
          setLoading(false);
          return;
        }

        // Fetch repository data from GitHub API
        const response = await fetch(`https://api.github.com/repos/${owner}/${repo}`);
        
        if (!response.ok) {
          throw new Error('Failed to fetch repository data');
        }
        
        const data = await response.json();
        setStars(data.stargazers_count);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching GitHub stars:', err);
        setError(true);
        setLoading(false);
      }
    };

    if (repoUrl) {
      fetchStars();
    }
  }, [repoUrl]);

  if (loading) {
    return (
      <div className={`flex items-center gap-1 ${className}`}>
        <FaStar className="text-yellow-400 animate-pulse" size={12} />
        <span className="text-xs text-white/70 animate-pulse">...</span>
      </div>
    );
  }

  if (error || stars === null) {
    return null; // Don't show anything if there's an error
  }

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <FaStar className="text-yellow-400" size={12} />
      <span className="text-xs text-white/90 font-medium">
        {stars.toLocaleString()}
      </span>
    </div>
  );
};

export default GitHubStars;